//Component Imports
import Header from "../Global/header";
import Footer from "../Global/footer";
import Article from "./article"

export default function PrivacyPage() {
  return (
    <main>
      <Header />
      <Article />
      <Footer />
    </main>
  );
}